// @ts-nocheck
import * as actionTypes from './wixCodeIDEActionTypes';

const overrideWixCodeIDE = (overrides) => ({
  type: actionTypes.OVERRIDE_WIX_CODE_IDE,
  overrides,
});

export { overrideWixCodeIDE };
